import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import API from "./config/API";

function ChangePassword() {
  const navigate = useNavigate();

  const location = useLocation();

  const { emailId, mobileNumber } = location.state || {};

  //==========================================
  // States
  //==========================================
  const [form, setForm] = useState({
    newPassword: "",

    confirmPassword: "",
  });

  const [errors, setErrors] = useState({});

  const [loading, setLoading] = useState(false);

  const [message, setMessage] = useState("");

  const [messageType, setMessageType] = useState("");

  const [showPassword, setShowPassword] = useState(false);

  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  //==========================================
  // Handle Change
  //==========================================

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,

      [name]: value,
    }));
  };

  //==========================================
  // Validation
  //==========================================

  const validate = () => {
    let err = {};

    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&()#^+=_.-])[A-Za-z\d@$!%*?&()#^+=_.-]{8,}$/;

    if (!form.newPassword.trim()) {
      err.newPassword = "New Password is required";
    } else if (!passwordRegex.test(form.newPassword)) {
      err.newPassword =
        "Password must contain at least 8 characters, one uppercase letter, one lowercase letter, one number and one special character.";
    }

    if (!form.confirmPassword.trim()) {
      err.confirmPassword = "Confirm Password is required";
    } else if (form.newPassword !== form.confirmPassword) {
      err.confirmPassword = "Passwords do not match";
    }

    setErrors(err);

    return Object.keys(err).length === 0;
  };
  //==========================================
  // Reset
  //==========================================

  const resetForm = () => {
    setForm({
      newPassword: "",

      confirmPassword: "",
    });

    setErrors({});

    setMessage("");

    setMessageType("");
  };

  //==========================================
  // Part 2 Starts Here
  // changePassword()
  //==========================================  //==========================================
  // Change Password API
  //==========================================

  const changePassword = async () => {
    if (!validate()) {
      return;
    }

    setLoading(true);

    setMessage("");

    setMessageType("");

    try {
      const payload = {
        emailId: emailId || null,

        mobileNumber: mobileNumber ? Number(mobileNumber) : null,

        newPassword: form.newPassword,

        confirmPassword: form.confirmPassword,
      };

      const response = await fetch(`${API.V2}/pgOwner/changePassword`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const res = await response.json();

      if (response.ok || res.statusCode === 200) {
        setMessageType("success");

        setMessage(res.message || "Password changed successfully.");

        setTimeout(() => {
          navigate("/");
        }, 2000);
      } else {
        setMessageType("error");

        setMessage(res.message || "Unable to change password.");
      }
    } catch (error) {
      console.error(error);

      setMessageType("error");

      setMessage("Unable to connect to the server.");
    } finally {
      setLoading(false);
    }
  };

  //==========================================
  // Toggle Password Visibility
  //==========================================

  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  //==========================================
  // Part 3 Starts Here
  // return(
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>Change Password</h2>

        <p style={styles.subTitle}>
          Create a strong password for your account.
        </p>

        {/* Success / Error Message */}

        {message && (
          <div
            style={{
              ...styles.message,
              background: messageType === "success" ? "#E8F5E9" : "#FFEBEE",
              color: messageType === "success" ? "#2E7D32" : "#C62828",
              border:
                messageType === "success"
                  ? "1px solid #81C784"
                  : "1px solid #EF9A9A",
            }}
          >
            {message}
          </div>
        )}

        {/* Email */}

        {emailId && (
          <div style={styles.field}>
            <label style={styles.label}>Registered Email</label>

            <input
              type="text"
              value={emailId}
              readOnly
              style={{
                ...styles.input,
                background: "#f5f5f5",
              }}
            />
          </div>
        )}

        {/* Mobile */}

        {mobileNumber && (
          <div style={styles.field}>
            <label style={styles.label}>Registered Mobile</label>

            <input
              type="text"
              value={mobileNumber}
              readOnly
              style={{
                ...styles.input,
                background: "#f5f5f5",
              }}
            />
          </div>
        )}

        {/* New Password */}

        <div style={styles.field}>
          <label style={styles.label}>New Password</label>

          <div style={styles.passwordBox}>
            <input
              type={showPassword ? "text" : "password"}
              name="newPassword"
              value={form.newPassword}
              onChange={handleChange}
              placeholder="Enter New Password"
              style={styles.passwordInput}
            />

            <button
              type="button"
              style={styles.eyeButton}
              onClick={togglePassword}
            >
              {showPassword ? "Hide" : "Show"}
            </button>
          </div>

          {errors.newPassword && (
            <span style={styles.error}>{errors.newPassword}</span>
          )}
        </div>

        {/* Confirm Password */}

        <div style={styles.field}>
          <label style={styles.label}>Confirm Password</label>

          <div style={styles.passwordBox}>
            <input
              type={showConfirmPassword ? "text" : "password"}
              name="confirmPassword"
              value={form.confirmPassword}
              onChange={handleChange}
              placeholder="Confirm Password"
              style={styles.passwordInput}
            />

            <button
              type="button"
              style={styles.eyeButton}
              onClick={toggleConfirmPassword}
            >
              {showConfirmPassword ? "Hide" : "Show"}
            </button>
          </div>

          {errors.confirmPassword && (
            <span style={styles.error}>{errors.confirmPassword}</span>
          )}
        </div>

        {/* Change Password Button */}

        <button
          style={styles.primaryButton}
          onClick={changePassword}
          disabled={loading}
        >
          {loading ? "Updating..." : "Change Password"}
        </button>

        {/* Reset */}

        <button
          style={styles.secondaryButton}
          onClick={resetForm}
          disabled={loading}
        >
          Reset
        </button>

        {/* Back */}

        <div style={styles.footer}>
          <span style={styles.loginLink} onClick={() => navigate("/")}>
            ← Back to Login
          </span>
        </div>
      </div>
    </div>
  );
}

export default ChangePassword;
const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient(135deg,#E3F2FD,#F8FBFF)",
    padding: "20px",
    fontFamily: "'Segoe UI', sans-serif",
  },

  card: {
    width: "100%",
    maxWidth: "480px",
    background: "#FFFFFF",
    borderRadius: "15px",
    padding: "35px",
    boxShadow: "0 15px 40px rgba(0,0,0,0.12)",
  },

  title: {
    textAlign: "center",
    color: "#1565C0",
    fontSize: "30px",
    fontWeight: "700",
    marginBottom: "10px",
  },

  subTitle: {
    textAlign: "center",
    color: "#607D8B",
    fontSize: "15px",
    marginBottom: "25px",
  },

  message: {
    padding: "12px",
    borderRadius: "8px",
    marginBottom: "20px",
    fontWeight: "600",
    textAlign: "center",
  },

  field: {
    marginBottom: "20px",
  },

  label: {
    display: "block",
    marginBottom: "8px",
    fontWeight: "600",
    color: "#37474F",
    fontSize: "14px",
  },

  input: {
    width: "100%",
    padding: "13px",
    border: "1px solid #CFD8DC",
    borderRadius: "8px",
    fontSize: "15px",
    boxSizing: "border-box",
    outline: "none",
  },

  passwordBox: {
    display: "flex",
    alignItems: "center",
    border: "1px solid #CFD8DC",
    borderRadius: "8px",
    overflow: "hidden",
    background: "#FFFFFF",
  },

  passwordInput: {
    flex: 1,
    padding: "13px",
    border: "none",
    outline: "none",
    fontSize: "15px",
  },

  eyeButton: {
    border: "none",
    background: "#F5F5F5",
    color: "#1565C0",
    cursor: "pointer",
    padding: "13px 18px",
    fontWeight: "600",
  },

  error: {
    color: "#D32F2F",
    fontSize: "12px",
    marginTop: "6px",
    display: "block",
    fontWeight: "600",
  },

  primaryButton: {
    width: "100%",
    padding: "14px",
    border: "none",
    borderRadius: "8px",
    background: "#1976D2",
    color: "#FFFFFF",
    fontSize: "16px",
    fontWeight: "700",
    cursor: "pointer",
    marginTop: "10px",
    transition: "0.3s",
  },

  secondaryButton: {
    width: "100%",
    padding: "14px",
    border: "2px solid #1976D2",
    borderRadius: "8px",
    background: "#FFFFFF",
    color: "#1976D2",
    fontSize: "16px",
    fontWeight: "700",
    cursor: "pointer",
    marginTop: "15px",
    transition: "0.3s",
  },

  footer: {
    marginTop: "30px",
    textAlign: "center",
  },

  loginLink: {
    color: "#1976D2",
    cursor: "pointer",
    fontWeight: "700",
    fontSize: "15px",
    textDecoration: "none",
  },
};
